// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"826":"7b991aba","1092":"928cbd28","4377":"ba4b2486","4840":"4137b440","5644":"f3caaee4","5864":"0b08488c"}[chunkId] + ".chunk.css";
};